import swal from "sweetalert2";

export async function confirmWithdrawReport(nomenclature) {
	try {
		const result = await swal.fire({
			title: `Withdraw ${nomenclature.PositiveReport}`,
			html: `Are you sure you want to withdraw this ${nomenclature.PositiveReport}?`,
			showCloseButton: true,
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#8CC541",
			confirmButtonText: "Yes"
		});

		return !result.dismiss;
	}catch(error) {		
		return false;
	}
}